import { GreyBlackFieldProps, HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { get } from "lodash";
import {
  convertToLocalDate, convertToLocalTimeString, convertToTimezoneUSATimeString, formattedDayTimeWithTimezone, relativeDateTime,
} from "helpers/time";
import { longAttributeStyles } from "components/DataDisplay/styles";
import ImmediateTag from "components/Tag/ImmediateTag";
import DateTimeZoneForm from "./DateTimeZonePopoverButton";

export const dateTimeZoneValues = (resource: object, datetimeFieldName: string): Partial<any> => {
  if (!resource) return {};
  const localDatetime = get(resource, datetimeFieldName);
  const timezone = get(resource, "timezone") || "UTC";

  return ({
    [datetimeFieldName]: localDatetime,
    timezone,
    [`local.${datetimeFieldName}.date`]: localDatetime ? convertToLocalDate(localDatetime, timezone) : undefined,
    [`local.${datetimeFieldName}.timeOfDay`]: localDatetime ? convertToLocalTimeString(localDatetime, timezone) : undefined,
  });
};

interface HorizontalDateAndTimeFieldProps extends GreyBlackFieldProps {
  form: any;
  fieldName: string;
  label: string;
  labelProps?: object;
  disabled?: boolean;
}

export default function HorizontalDateAndTimeField({
  form, fieldName, label, disabled = false, labelProps = {}, ...props
}: HorizontalDateAndTimeFieldProps) {
  return (
    <HorizontalGreyBlackField
      label={label}
      iconProps={{ alignSelf: "flex-end" }}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={labelProps}
      {...props}
    >
      <DateTimeZoneForm form={form} datetimeFieldName={fieldName} label={label} disabled={disabled} />
    </HorizontalGreyBlackField>
  );
}

interface ShowDateTimeProps extends GreyBlackFieldProps {
  date?: Date;
  label: string;
  timezone?: string;
  labelProps?: object;
  noDateText?: string;
}

export function ShowRelativeDateTime({
  date, timezone, label, noDateText = "None", labelProps = {}, ...props
}: ShowDateTimeProps) {
  let addOn;
  let dateText;
  if (date) {
    addOn = timezone ? ` (${convertToTimezoneUSATimeString(date, timezone)} ${timezone})` : "";
    dateText = relativeDateTime(date);
  }
  return (
    <HorizontalGreyBlackField
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={labelProps}
      {...props}
    >
      {date ? `${dateText}${addOn}` : noDateText}
    </HorizontalGreyBlackField>
  );
}

export function ShowDateTime({
  date, timezone, label, noDateText = "None", labelProps = {}, ...props
}: ShowDateTimeProps) {
  // Friday, July 20th at 12:00pm (PDT)
  return (
    <HorizontalGreyBlackField
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={labelProps}
      {...props}
    >
      {date ? formattedDayTimeWithTimezone(date) : noDateText}
    </HorizontalGreyBlackField>
  );
}

interface ShowImmediateProps extends GreyBlackFieldProps {
  label: string;
  localTimezone?: string;
  labelProps?: object;
}

export function ShowImmediate({ label, labelProps = {}, ...props }: ShowImmediateProps) {
  return (
    <HorizontalGreyBlackField
      label={label}
      labelContainerProps={longAttributeStyles.labelContainerProps}
      labelProps={labelProps}
      {...props}
    >
      <ImmediateTag />
    </HorizontalGreyBlackField>
  );
}
